/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Auto_Embed_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "Yes, if you want uploads to be usable in chats immediately. Turn it off only when you prefer to embed files selectively, for example to control cost or exclu..." |
*
* @param {Uno_Edu_Space_Auto_Embed_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_auto_embed_chip2_answer = /** @type {((inputs?: Uno_Edu_Space_Auto_Embed_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Auto_Embed_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja, wenn hochgeladene Dateien sofort in Chats nutzbar sein sollen. Deaktivieren Sie sie nur, wenn Sie Dateien gezielt einbetten möchten, etwa um Kosten zu steuern oder Entwürfe auszuschließen.")
	return /** @type {LocalizedString} */ ("Yes, if you want uploads to be usable in chats immediately. Turn it off only when you prefer to embed files selectively, for example to control cost or exclude drafts.")
});